import {Base64} from "js-base64";

function check(dataset) {
    return dataset.aceInteractiveCode === undefined && dataset.aceInteractiveCode !== ''
}

export function initAceEditor(text, id, mod) {
    const parser = new DOMParser();
    const htmlDoc = parser.parseFromString(text, 'text/html');
    const pres = htmlDoc.querySelectorAll('pre');
    const pres_text = text.split('</pre>');
    let res = '';
    const len = pres.length;

    for (let i = 0; i < len; i++) {
        let lang = '';

        pres[i].classList.forEach((e) => {
            if (e.startsWith('language-')) {
                lang = e.split('-')[1];
            }
        })

        res += `${pres_text[i]}</pre><coderunner id="${id}" mode="${mod}" code="${Base64.encode(pres[i].textContent)}" 
        language="${lang}" button="${pres[i].dataset.buttonName}" stdin="${pres[i].dataset.stdinTaid}" 
        files=\'${pres[i].dataset.fileTaids}\' read=${check(pres[i].dataset)}></coderunner>`;
    }

    if (pres_text.length > len) {
        res += pres_text[pres_text.length - 1];
    }

    return res.replaceAll('<pre', '<pre hidden ');
}